import React from 'react';
import { tv } from 'tailwind-variants';
import { statusVariants, type StatusAppearances, type StatusIntents } from '~/theme/variants';

const badgeStyles = tv({
	extend: statusVariants,
	base: 'inline-flex items-center rounded border px-2 py-0.5 text-[11px] font-semibold',
	defaultVariants: {
		intent: 'neutral',
		appearance: 'subtle'
	}
});

export interface BadgeProps {
	intent?: StatusIntents;
	appearance?: StatusAppearances;
	className?: string;
	children: React.ReactNode;
}

export function Badge({ intent = 'neutral', appearance, className, children }: BadgeProps) {
	return <span className={badgeStyles({ intent, appearance, className })}>{children}</span>;
}
